import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

const optInTransactional = async ({
  clinicPath,
  phoneNumber,
}: {
  clinicPath: string;
  phoneNumber: string;
}) => {
  return ChiroUpAPI.post('api-noauth', '/sms-optin', {
    body: {
      clinicPath,
      phoneNumber,
      smsConsent: true,
      smsConsentMarketing: false,
    },
  });
};

const smsOptinService = {
  optInTransactional,
};

export default smsOptinService;
